@if (isOpen) {
  <div
    class="fixed bottom-5 right-5 w-85 overflow-hidden rounded-lg bg-white shadow-xl"
  >
    <div class="flex max-h-12 items-center gap-2 px-1 py-1.5">
      <span class="truncate px-2 text-sm font-semibold"> {{ title() }}</span>

      <p-button
        class="ml-auto"
        size="small"
        severity="contrast"
        variant="text"
        [disabled]="!queueItems()?.length"
        [pTooltip]="isExpanded ? 'Collapse' : 'Expand'"
        tooltipPosition="left"
        (click)="onToggleQueueIndicator()"
      >
        <ng-template #icon>
          @if (isExpanded) {
            <svg-icon src="/assets/icons/general/chevron-down.svg" />
          }
          @if (!isExpanded) {
            <svg-icon src="/assets/icons/general/chevron-up.svg" />
          }
        </ng-template>
      </p-button>

      <p-button
        size="small"
        severity="contrast"
        variant="text"
        pTooltip="Close"
        tooltipPosition="left"
        (click)="onCloseEvent()"
      >
        <ng-template #icon>
          <svg-icon src="/assets/icons/general/close.svg" />
        </ng-template>
      </p-button>
    </div>

    @if (hasCompletionBar()) {
      <div
        class="flex max-h-9 w-full items-center gap-2 bg-french-blue-50 px-4 py-2"
      >
        <span class="truncate text-sm text-french-blue-700">
          {{ successQueueItemsCount() }}/{{ queueItemsCount() }} items complete
        </span>
        <ag1-link
          class="ml-auto"
          variant="secondary"
          label="View"
          [disabled]="successQueueItemsCount() === 0"
          (clickEvent)="onViewClick()"
        />
      </div>
    }
    @if (isExpanded) {
      <div class="my-1 grid max-h-60 grid-cols-1 gap-1 overflow-y-auto">
        @for (queueItem of queueItems(); track queueItem; let index = $index) {
          <ag1-queue-item
            [queueItem]="queueItem"
            (itemClickEvent)="onItemClick(queueItem)"
          />
        }
      </div>
    }
  </div>
}
